
























import Vue from "vue";
import { $eventsBus } from "@/main";

export default Vue.extend({
  name: "RendersPreviewWindow",
  components: {},
  data: function () {
    return {
      currentItem: /* {
        outputName: "",
        path: "",
      } */ null,
      mutedStateBeforeOpen: true,
      localMuted: true,
    };
  },
  computed: {
    renderItems: {
      // getter
      get: function () {
        return this.$store.state.renderItems;
      },
      // setter
      set: function (newValue) {},
    },
    muted: {
      // getter
      get: function () {
        return this.$store.state.muted;
      },
      // setter
      set: function (newValue) {
        this.$store.commit("muted", newValue);
      },
    },
    keymap: function () {
      return {
        esc: this.exit,
        "ctrl+left": this.swipeLeft,
        "ctrl+right": this.swipeRight,
        space: {
          keyup: this.playPause,
        },
      };
    },
  },

  created() {
    $eventsBus.$on("showRenderItemPreview", (item) => {
      this.onOpen(item);
    });
  },
  watch: {},
  methods: {
    onOpen(item) {
      this.currentItem = item;
      this.mutedStateBeforeOpen = this.muted;
      this.localMuted = this.muted;
      this.muted = true;
    },
    exit() {
      //muted
      this.muted = this.mutedStateBeforeOpen;
      this.currentItem = null;
      this.$emit("close");
    },
    swipeLeft() {
      let doneTasks = this.renderItems.filter((i) => i.loaded);
      let itemIndex = doneTasks.indexOf(this.currentItem);
      let leftIndex = itemIndex === 0 ? doneTasks.length - 1 : itemIndex - 1;
      this.currentItem = doneTasks[leftIndex];
    },
    swipeRight() {
      let doneTasks = this.renderItems.filter((i) => i.loaded);
      let itemIndex = doneTasks.indexOf(this.currentItem);
      let rightIndex = itemIndex === doneTasks.length - 1 ? 0 : itemIndex + 1;
      this.currentItem = doneTasks[rightIndex];
    },
    playPause() {
      let renderedVideo = this.$refs.renderedVideo;
      renderedVideo.paused ? renderedVideo.play() : renderedVideo.pause();
    },
  },
});
